module.exports = __webpack_public_path__ + "img/logo-cur.ad5edc1c.png";